import FHGLogo from "../assets/icons/fhg-logo.svg";

export default function Logo() {
  return (
    <div className="absolute top-0 left-0 w-52 m-4 z-10">
      <FHGLogo />
    </div>
  );
}
